const getCertificates = (state) => state.certificate.certificates.items
const getCertificatesLoading = (state) => state.certificate.certificates.loading
const getCertificatesPages = (state) => state.certificate.certificates.totalPages

export default {
  getCertificates,
  getCertificatesLoading,
  getCertificatesPages
}
